@import "tailwindcss";

@theme {
  --color-border: hsl(var(--border));
  --color-input: hsl(var(--input));
  --color-ring: hsl(var(--ring));
  --color-background: hsl(var(--background));
  --color-foreground: hsl(var(--foreground));

  --color-primary: hsl(var(--primary));
  --color-primary-foreground: hsl(var(--primary-foreground));

  --color-secondary: hsl(var(--secondary));
  --color-secondary-foreground: hsl(var(--secondary-foreground));

  --color-destructive: hsl(var(--destructive));
  --color-destructive-foreground: hsl(var(--destructive-foreground));

  --color-muted: hsl(var(--muted));
  --color-muted-foreground: hsl(var(--muted-foreground));

  --color-accent: hsl(var(--accent));
  --color-accent-foreground: hsl(var(--accent-foreground));

  --color-popover: hsl(var(--popover));
  --color-popover-foreground: hsl(var(--popover-foreground));

  --color-card: hsl(var(--card));
  --color-card-foreground: hsl(var(--card-foreground));

  --color-success: hsl(var(--success));
  --color-danger: hsl(var(--danger));
  --color-warning: hsl(var(--warning));

  --radius-lg: var(--radius);
  --radius-md: calc(var(--radius) - 2px);
  --radius-sm: calc(var(--radius) - 4px);

  --animate-accordion-down: accordion-down 0.2s ease-out;
  --animate-accordion-up: accordion-up 0.2s ease-out;

  @keyframes accordion-down {
    from {
      height: 0;
    }
    to {
      height: var(--radix-accordion-content-height);
    }
  }
  @keyframes accordion-up {
    from {
      height: var(--radix-accordion-content-height);
    }
    to {
      height: 0;
    }
  }
}

@utility container {
  margin-inline: auto;
  padding-inline: 2rem;
  @media (width >= 1400px) {
    max-width: 1400px;
  }
}

@layer base {
  :root {
    --background: 0 0% 100%;
    --foreground: 222.2 84% 4.9%;

    --card: 0 0% 100%;
    --card-foreground: 222.2 84% 4.9%;

    --popover: 0 0% 100%;
    --popover-foreground: 222.2 84% 4.9%;

    --primary: 221.2 83.2% 53.3%;
    --primary-foreground: 210 40% 98%;

    --secondary: 210 40% 96.1%;
    --secondary-foreground: 222.2 47.4% 11.2%;

    --muted: 210 40% 96.1%;
    --muted-foreground: 215.4 16.3% 46.9%;

    --accent: 210 40% 96.1%;
    --accent-foreground: 222.2 47.4% 11.2%;

    --destructive: 0 84.2% 60.2%;
    --destructive-foreground: 210 40% 98%;

    --border: 214.3 31.8% 91.4%;
    --input: 214.3 31.8% 91.4%;
    --ring: 221.2 83.2% 53.3%;

    --success: 142.1 70.6% 45.3%;
    --danger: 0 84.2% 60.2%;
    --warning: 38 92% 50%;

    --radius: 0.75rem;
  }

  .dark {
    --background: 222.2 84% 4.9%;
    --foreground: 210 40% 98%;

    --card: 222.2 84% 4.9%;
    --card-foreground: 210 40% 98%;

    --popover: 222.2 84% 4.9%;
    --popover-foreground: 210 40% 98%;

    --primary: 217.2 91.2% 59.8%;
    --primary-foreground: 222.2 47.4% 11.2%;

    --secondary: 217.2 32.6% 17.5%;
    --secondary-foreground: 210 40% 98%;

    --muted: 217.2 32.6% 17.5%;
    --muted-foreground: 215 20.2% 65.1%;

    --accent: 217.2 32.6% 17.5%;
    --accent-foreground: 210 40% 98%;

    --destructive: 0 62.8% 30.6%;
    --destructive-foreground: 210 40% 98%;

    --border: 217.2 32.6% 17.5%;
    --input: 217.2 32.6% 17.5%;
    --ring: 224.3 76.3% 48%;

    --success: 142.1 70.6% 45.3%;
    --danger: 0 84.2% 60.2%;
    --warning: 38 92% 50%;
  }

  .light-simple {
    --background: 210 20% 98%;
    --foreground: 215 25% 15%;

    --card: 210 20% 98%;
    --card-foreground: 215 25% 15%;

    --popover: 210 20% 98%;
    --popover-foreground: 215 25% 15%;

    --primary: 215 20% 45%;
    --primary-foreground: 0 0% 100%;

    --secondary: 210 20% 92%;
    --secondary-foreground: 215 25% 20%;

    --muted: 210 20% 92%;
    --muted-foreground: 215 15% 45%;

    --accent: 210 20% 92%;
    --accent-foreground: 215 25% 20%;

    --destructive: 0 0% 40%;
    --destructive-foreground: 210 20% 98%;

    --border: 214 10% 85%;
    --input: 214 10% 85%;
    --ring: 215 20% 45%;

    --success: 142 30% 55%;
    --danger: 0 40% 65%;
    --warning: 38 40% 60%;

    --radius: 0.5rem;
  }
}

@layer base {
  * {
    @apply border-border;
  }
  body {
    @apply bg-background text-foreground font-sans;
  }
}

/* * {
  outline: 1px solid red;
} */

/* ─── 클릭/인터랙션 가능 요소 커서 ──────────────────────────── */
button,
[role="button"],
[role="tab"],
[role="menuitem"],
a,
label,
select,
input[type="checkbox"],
input[type="radio"],
input[type="submit"],
input[type="button"],
summary {
  cursor: pointer;
}

/* onClick이 붙은 div/card 등 */
[onclick]:not([disabled]),
.cursor-pointer {
  cursor: pointer;
}

